// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__qwh71","white":"Button_white__74QZt","s-size":"Button_s-size__wXNBY","upper":"Button_upper__3_ftH","wide":"Button_wide__19zlS"};